import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@rudi/api/react';
import type { ClusterReport, UsageSample } from '@cortex/cluster-report';

export type {
  ClusterReport,
  LoadAverage,
  NodeReport,
  PodReport,
  Resources,
  Filesystem,
  GpuReport,
  UsageSample,
} from '@cortex/cluster-report';

export interface ClusterView {
  id: string;
  label: string;
  /** `waiting` means the Receptor has not reported since the backend started. */
  status: 'reporting' | 'unreachable' | 'waiting';
  receivedAt: string | null;
  report: ClusterReport | null;
  /** Each node's usage over the last hour, oldest first. */
  history: UsageSample[];
}

export interface ClustersResponse {
  staleAfterSeconds: number;
  clusters: ClusterView[];
}

export const CLUSTER_REFRESH_MS = 15_000;

export function useClusters() {
  const api = useApiClient();
  return useQuery({
    queryKey: ['clusters'],
    queryFn: async () => (await api.get<ClustersResponse>('/clusters')).data,
    refetchInterval: CLUSTER_REFRESH_MS,
  });
}
